import React, { useState, useEffect } from "react";
import { Container, Navbar, Nav, Button, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FaSignOutAlt, FaUser, FaClock } from "react-icons/fa";

const Header = () => {
  const { currentUser, logout } = useAuth();
  const [sessionTimeLeft, setSessionTimeLeft] = useState(null);

  useEffect(() => {
    let interval;

    // Check for session expiration time
    if (currentUser) {
      const checkSessionTime = () => {
        const tokenData = localStorage.getItem("token");
        if (!tokenData) return;

        try {
          // JWT tokens have three parts separated by dots
          const tokenParts = tokenData.split(".");
          if (tokenParts.length !== 3) return;

          // The second part contains the payload (in base64)
          const payload = JSON.parse(atob(tokenParts[1]));

          if (payload.exp) {
            const expiryTime = payload.exp * 1000; // Convert to milliseconds
            const currentTime = Date.now();
            const timeLeft = Math.max(
              0,
              Math.floor((expiryTime - currentTime) / 60000)
            ); // Convert to minutes

            setSessionTimeLeft(timeLeft);

            // If session is about to expire (less than 5 minutes), show warning
            if (timeLeft < 5) {
              // You could show a more prominent warning here
            }
          }
        } catch (e) {
          console.error("Error checking token expiration:", e);
        }
      };

      // Check immediately and then every minute
      checkSessionTime();
      interval = setInterval(checkSessionTime, 60000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [currentUser]);

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="mb-0">
      <Container>
        <Navbar.Brand as={Link} to="/">
          Profundus License Manager
        </Navbar.Brand>
        {currentUser && (
          <>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse
              id="basic-navbar-nav"
              className="justify-content-end"
            >
              <Nav>
                {sessionTimeLeft !== null && (
                  <div className="d-flex align-items-center text-light me-3">
                    <FaClock className="me-2" />
                    <Badge bg={sessionTimeLeft > 10 ? "success" : "warning"}>
                      Session: {sessionTimeLeft} min
                    </Badge>
                  </div>
                )}
                <div className="d-flex align-items-center text-light me-3">
                  <FaUser className="me-2" />
                  <span>{currentUser.name || currentUser.email}</span>
                </div>
                <Button variant="outline-light" size="sm" onClick={logout}>
                  <FaSignOutAlt className="me-2" />
                  Logout
                </Button>
              </Nav>
            </Navbar.Collapse>
          </>
        )}
      </Container>
    </Navbar>
  );
};

export default Header;
